
export const MAX_BADGE_COUNT = 99;

/**
 * Formats a count for a fixed-size badge.
 * @param {number} count - The raw count
 * @returns {string} The count, or "99+" once it would overflow the badge
 */
export const formatBadgeCount = (count) => {
	const value = Number(count) || 0;

	return value > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(value);
};
